/**
 * Turn a hyphenated slug (e.g. `'space-marines-ultramarines'`) into Title Case words (`'Space Marines
 * Ultramarines'`).
 */
export function humanize(slug: string): string {
    return slug
        .split('-')
        .filter(Boolean)
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(' ');
}
